import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import actfilter from "../../assets/icons/Filter contacts.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ListItemText from "@mui/material/ListItemText";
import {
  AiOutlineCloseCircle,
  AiOutlineRight,
  AiOutlineDown,
} from "react-icons/ai";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { MdLens, MdOutlineLens } from "react-icons/md";
import InputAdornment from "@mui/material/InputAdornment";
import { FiSearch } from "react-icons/fi";
import OutlinedInput from "@mui/material/OutlinedInput";
import crossIcon from "../../assets/icons/x-circle-2.svg";
import "../../assets/styles/local/ProFilter.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SelectedFilter = ({ filterItem, setFilterItem }) => {
  return (
    <div className="pro-part-filter-btn-con">
      <div className="pro-part-filter-btn-label">{filterItem}</div>
      <div onClick={() => setFilterItem("")} className="cursor-pointer">
        x
      </div>
    </div>
  );
};

const ColorPopup = ({
  anchorEl,
  open,
  handleClose,
  dummy,
  productDataList,
  setSendColor,
}) => {
  console.log("asc45color", productDataList);

  const [ascColor, setAscColor] = useState("");

  return (
    <Menu
      id="basic-color-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-color-button",
      }}
      sx={{
        "& .MuiMenu-paper": {
          borderRadius: "1px",
          background: "#f8f9fa 0% 0% no-repeat padding-box;",
          height: "120px",
          width: "110px",
        },
        "& .MuiMenu-root": {},
        "& .MuiPaper-root": {
          left: dummy ? "500px !important" : "380px !important",
          top: "250px !important",
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          enuItem
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "12px",
            flexWrap: "wrap",
            "&:hover": { background: "transparent", cursor: "default" },
          }}
        >
          <div className="d-flex flex-wrap gap-4 pointer">
            {productDataList?.map((item) => {
              return item.colorcode.map((x) => {
                return (
                  <p
                    className="pro-part-col-tag"
                    style={{ background: `${x.color}` }}
                    onClick={() => {
                      setAscColor(x.color);
                      setSendColor(x.color);
                      handleClose();
                    }}
                  ></p>
                );
              });
            })}
          </div>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

const BrandPopup = ({
  anchorEl,
  open,
  handleClose,
  dummy,
  productDataList,
  setSendBrandandSuppliers,
  setSendBrandName,
  FetchTranslationList,
}) => {
  console.log("asc45Brand", productDataList);

  const [selectedBrandSupplier, setSelectedBrandSupplier] = useState([]);
  const [selectedBrandName, setSelectedBrandName] = useState([]);
  const [searchBrand, setSearchBrand] = useState("");

  const t = (key) => FetchTranslationList?.[key] || "";
  console.log("asc45selectedBrand", setSendBrandName);

  return (
    <Menu
      id="basic-brand-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-brand-button",
      }}
      sx={{
        "& .MuiMenu-paper": {
          borderRadius: "1px",
          background: "#f8f9fa 0% 0% no-repeat padding-box;",
          height: "160px",
          width: "250px",
          overflow: "scroll",
        },
        "& .MuiMenu-root": {},
        "& .MuiPaper-root": {
          left: dummy ? "500px !important" : "380px !important",
          top: "290px !important",
          padding: 0,
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          enuItem
          onKeyDown={(e) => e.stopPropagation()}
          sx={{
            marginTop: "2rem",
            "&:hover": { background: "transparent", cursor: "default" },
          }}
        >
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                //   position: "absolute !important",
                //   top: "-20px !important",
                //   right: "15px !important",
              },
            }}
          >
            <OutlinedInput
              id="cat-search"
              size="small"
              // placeholder="Search"
              placeholder={t("Search")}
              value={searchBrand}
              onChange={(e) => setSearchBrand(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <FiSearch />
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "search",
              }}
              sx={{ height: "31px", width: "221px" }}
            />
          </ListItemText>
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            paddingTop: "0px",
            paddingBottom: "0px",
            "&:hover": { background: "transparent", cursor: "default" },
          }}
        >
          <div>
            {/* for Brand filter */}
            <div className="pointer pt-2" id="ascInputFilter">
              {[
                ...new Map(
                  productDataList
                    ?.filter(
                      (x) =>
                        x.brand?.trim() &&
                        x.brand
                          .toLowerCase()
                          .includes(searchBrand.toLowerCase()),
                    )
                    .map((item) => [item.brand, item]),
                ).values(),
              ].map((item) => {
                return (
                  <div className="d-flex gap-3">
                    <input
                      class="form-check-input pointer"
                      type="checkbox"
                      // value="Not invoiced"
                      id={item.productPartid}
                      // when want to checked one by one checkBox
                      checked={selectedBrandName.find(
                        (data) => data.pushedID === item.productPartid,
                      )}
                      onClick={() => {
                        let index2 = selectedBrandName.findIndex(
                          (x) => x.pushedID === item.productPartid,
                        );

                        if (index2 !== -1) {
                          let data = [...selectedBrandName];
                          data.splice(index2, 1);
                          setSelectedBrandName(data);
                          return;
                        }

                        let pushingItem = [...selectedBrandName];
                        pushingItem.push({
                          // pushedName: `${item.brand}/${item.suppliername}`,
                          pushedBrandName: item.brand,
                          // pushedBrandID: item.brandid,
                          pushedSupplierID: item.supplierid,
                        });
                        setSelectedBrandName(pushingItem);
                        setSendBrandName(pushingItem[0]?.pushedBrandName);

                        handleClose();
                        setSelectedBrandName([]);
                      }}
                    />
                    <label htmlFor={item.productPartid}>
                      {/* <p>{`${item.brand}/${item.suppliername}`}</p> */}
                      <p>{item.brand}</p>
                    </label>
                  </div>
                );
              })}
            </div>

            {/* for Suppliers filter */}
            <div className="pointer" id="ascInputFilter">
              {[
                ...new Map(
                  productDataList
                    ?.filter(
                      (x) =>
                        x.suppliername?.trim() &&
                        x.suppliername
                          ?.toLowerCase()
                          .includes(searchBrand?.toLowerCase()),
                    )
                    .map((item) => [item.suppliername, item]),
                ).values(),
              ].map((item) => {
                return (
                  <div className="d-flex gap-3">
                    <input
                      class="form-check-input pointer"
                      type="checkbox"
                      // value="Not invoiced"
                      id={item.productPartid}
                      // when want to checked one by one checkBox
                      checked={selectedBrandSupplier.find(
                        (data) => data.pushedID === item.productPartid,
                      )}
                      onClick={() => {
                        let index2 = selectedBrandSupplier.findIndex(
                          (x) => x.pushedID === item.productPartid,
                        );

                        if (index2 !== -1) {
                          let data = [...selectedBrandSupplier];
                          data.splice(index2, 1);
                          setSelectedBrandSupplier(data);
                          return;
                        }

                        let pushingItem = [...selectedBrandSupplier];
                        pushingItem.push({
                          // pushedName: `${item.brand}/${item.suppliername}`,
                          pushedSupplierName: item.suppliername,
                          pushedSupplierID: item.supplierid,
                        });
                        setSelectedBrandSupplier(pushingItem);
                        setSendBrandandSuppliers(
                          pushingItem[0]?.pushedSupplierName,
                        );

                        handleClose();
                        setSelectedBrandSupplier([]);
                      }}
                    />
                    <label htmlFor={item.productPartid}>
                      {/* <p>{`${item.brand}/${item.suppliername}`}</p> */}
                      <p>{item.suppliername}</p>
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

const CatPopup = ({
  anchorEl,
  open,
  handleClose,
  dummy,
  productDataList,
  setSendCategories,
}) => {
  console.log("asc45Catege", productDataList);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchCategory, setSearchCategory] = useState("");

  return (
    <Menu
      id="basic-cat-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-cat-button",
      }}
      sx={{
        "& .MuiMenu-paper": {
          borderRadius: "1px",
          background: "#f8f9fa 0% 0% no-repeat padding-box;",
          height: "160px",
          width: "250px",
          overflow: "scroll",
        },
        "& .MuiMenu-root": {},
        "& .MuiPaper-root": {
          left: dummy ? "500px !important" : "380px !important",
          top: "340px !important",
          padding: 0,
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          enuItem
          onKeyDown={(e) => e.stopPropagation()}
          sx={{
            marginTop: "2rem",
            "&:hover": { background: "transparent", cursor: "default" },
          }}
        >
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                //   position: "absolute !important",
                //   top: "-20px !important",
                //   right: "15px !important",
              },
            }}
          >
            <OutlinedInput
              id="cat-search"
              size="small"
              placeholder="Search categories"
              value={searchCategory}
              onChange={(e) => setSearchCategory(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <FiSearch />
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "search",
              }}
              sx={{ height: "31px", width: "221px" }}
            />
          </ListItemText>
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            paddingTop: "0px",
            paddingBottom: "0px",
            "&:hover": { background: "transparent", cursor: "default" },
          }}
        >
          <div className="pointer pt-2" id="ascInputFilter">
            {[
              ...new Map(
                productDataList
                  ?.map((item) => item.productpartcategories)
                  .flat()
                  ?.filter(
                    (x) =>
                      x?.categories?.trim() &&
                      x.categories
                        .toLowerCase()
                        .includes(searchCategory.toLowerCase()),
                  )
                  ?.map((x) => [x.categories, x]),
              ).values(),
            ].map((x) => {
              return (
                <div className="d-flex gap-3">
                  <input
                    class="form-check-input pointer"
                    type="checkbox"
                    // value="Not invoiced"
                    id={x.productpartcategorieid}
                    // when want to checked one by one checkBox
                    checked={selectedCategories.find(
                      (data) => data.pushedID === x.productpartcategorieid,
                    )}
                    onClick={() => {
                      let index2 = selectedCategories.findIndex(
                        (z) => z.pushedID === x.productpartcategorieid,
                      );

                      if (index2 !== -1) {
                        let data = [...selectedCategories];
                        data.splice(index2, 1);
                        setSelectedCategories(data);
                        return;
                      }

                      let pushingItem = [...selectedCategories];
                      pushingItem.push({
                        pushedCategName: x.categories,
                        pushedCategID: x.productpartcategorieid,
                      });
                      setSelectedCategories(pushingItem);
                      setSendCategories(pushingItem[0]?.pushedCategName);

                      handleClose();
                      setSelectedCategories([]);
                    }}
                  />
                  <label htmlFor={x.productpartcategorieid}>
                    <p>{x.categories}</p>
                  </label>
                </div>
              );
            })}
          </div>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

const FilterPopup = ({
  anchorEl,
  open,
  handleClose,
  setFilterItem,
  productDataList,
  setSendColor,
  setSendBrandandSuppliers,
  setSendBrandName,
  setSendCategories,
  setSendClearFilter,
  setSelectedFilteredItem,
  FetchTranslationList,
  setFetchTranslationList,
}) => {
  const [dummy, setDummy] = useState(true); // need to change this state as false when sidebar is not expanded
  const [anchorElColor, setAnchorElColor] = React.useState(null);
  const openColor = Boolean(anchorElColor);
  const t = (key) => FetchTranslationList?.[key] || "";
  const handleClickColor = (event) => {
    setAnchorElColor(event.currentTarget);
  };
  const handleCloseColor = () => {
    setAnchorElColor(null);
  };

  const [anchorElBrand, setAnchorElBrand] = React.useState(null);
  const openBrand = Boolean(anchorElBrand);
  const handleClickBrand = (event) => {
    setAnchorElBrand(event.currentTarget);
  };
  const handleCloseBrand = () => {
    setAnchorElBrand(null);
  };

  const [anchorElCat, setAnchorElCat] = React.useState(null);
  const openCat = Boolean(anchorElCat);
  const handleClickCat = (event) => {
    setAnchorElCat(event.currentTarget);
  };
  const handleCloseCat = () => {
    setAnchorElCat(null);
  };

  const [isProductChecked, setIsProductChecked] = React.useState(false);
  const [isPartsChecked, setIsPartsChecked] = React.useState(false);
  const [isServiceChecked, setIsServiceChecked] = React.useState(false);
  const [isColorChecked, setIsColorChecked] = React.useState(false);
  const [isBrandChecked, setIsBrandChecked] = React.useState(false);
  const [isCatChecked, setIsCatChecked] = React.useState(false);

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      sx={{
        "& .MuiMenu-paper": {
          borderRadius: "8px",
          background: "#FFFFFF 0% 0% no-repeat padding-box;",
          boxShadow: "0px 6px 12px #2D2E1C1A;",
          // background: "#ffff 0% 0% no-repeat padding-box;",
          // height: "445px",
          width: "222px",
          paddingTop: "30px",
        },
        "& .MuiMenu-root": {},
        "& .MuiPaper-root": {
          // left: "1064px !important",
          top: "80px !important",
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          enuItem
          sx={{ "&:hover": { background: "transparent", cursor: "default" } }}
        >
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                position: "absolute !important",
                top: "-30px !important",
                right: "15px !important",
              },
            }}
          >
            <AiOutlineCloseCircle
              color="#BFBFBF"
              fontSize="1.2rem"
              onClick={handleClose}
            />
          </ListItemText>
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
        >
          <FormControlLabel
            // value="Products"
            value={t("Products")}
            control={
              <Radio
                name="filter"
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isProductChecked}
                onClick={() => {
                  setFilterItem("Product");
                  setIsProductChecked(true);
                  setIsPartsChecked(false);
                  setIsServiceChecked(false);
                  setIsBrandChecked(false);
                  setIsCatChecked(false);
                  setIsColorChecked(false);

                  setSelectedFilteredItem("Product");
                }}
              />
            }
            // label="Products"
            label={t("Products")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isProductChecked} ? #00246A : #333333`,
                fontWeight: isProductChecked
                  ? "800 !important"
                  : "bold !important",
              },
            }}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
        >
          <FormControlLabel
            // value="Parts"
            value={t("Parts")}
            control={
              <Radio
                name="filter"
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isPartsChecked}
                onClick={() => {
                  setFilterItem("Part");
                  setIsPartsChecked(true);
                  setIsServiceChecked(false);
                  setIsProductChecked(false);
                  setIsBrandChecked(false);
                  setIsCatChecked(false);
                  setIsColorChecked(false);

                  setSelectedFilteredItem("Part");
                }}
              />
            }
            // label="Parts"
            label={t("Parts")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isPartsChecked} ? #00246A : #333333`,
                fontWeight: isPartsChecked
                  ? "800 !important"
                  : "bold !important",
              },
            }}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
          className=""
        >
          <FormControlLabel
            // value="Parts"
            value={t("Parts")}
            control={
              <Radio
                name="filter"
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isServiceChecked}
                onClick={() => {
                  setFilterItem("Service");
                  setIsServiceChecked(true);
                  setIsPartsChecked(false);
                  setIsProductChecked(false);
                  setIsBrandChecked(false);
                  setIsCatChecked(false);
                  setIsColorChecked(false);

                  setSelectedFilteredItem("Service");
                }}
              />
            }
            // label="Service"
            label={t("Services")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isServiceChecked} ? #00246A : #333333`,
                fontWeight: isServiceChecked
                  ? "800 !important"
                  : "bold !important",
              },
            }}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            display: "flex !important",
            justifyContent: "space-between !important",
            paddingRight: "0",
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
        >
          <FormControlLabel
            // value="Colors"
            value={t("Colors")}
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isColorChecked}
                onClick={() => {
                  setIsColorChecked(!isColorChecked);
                  // setFilterItem("Colors");
                  setIsPartsChecked(false);
                  setIsServiceChecked(false);
                  setIsProductChecked(false);
                  setIsBrandChecked(false);
                  setIsCatChecked(false);
                  setIsColorChecked(true);
                  setAnchorElColor(true);

                  setSelectedFilteredItem("Colors");
                }}
              />
            }
            // label="Colors"
            label={t("Colors")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isColorChecked} ? #00246A : #333333`,
                fontWeight: isColorChecked
                  ? "800 !important"
                  : "bold !important",
              },
            }}
          />
          {!openColor ? (
            <AiOutlineRight
              id="basic-color-button"
              aria-controls={openColor ? "basic-color-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openColor ? "true" : undefined}
              onClick={handleClickColor}
            />
          ) : (
            <AiOutlineDown />
          )}
          <ColorPopup
            dummy={dummy}
            anchorEl={anchorElColor}
            open={openColor}
            productDataList={productDataList}
            setSendColor={setSendColor}
            handleClose={handleCloseColor}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            display: "flex !important",
            justifyContent: "space-between !important",
            paddingRight: "0",
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
        >
          <FormControlLabel
            // value="Brand/Suppliers"
            value={t("Brand/Suppliers")}
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isBrandChecked}
                onClick={() => {
                  setIsBrandChecked(!isBrandChecked);
                  // setFilterItem("Brand/Suppliers");
                  setIsPartsChecked(false);
                  setIsServiceChecked(false);
                  setIsProductChecked(false);
                  setIsBrandChecked(true);
                  setIsCatChecked(false);
                  setIsColorChecked(false);
                  setAnchorElBrand(true);

                  setSelectedFilteredItem("Brand/Suppliers");
                }}
              />
            }
            // label="Brand/Suppliers"
            label={t("Brand/Suppliers")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isBrandChecked} ? #00246A : #333333`,
                fontWeight: isBrandChecked
                  ? "800 !important"
                  : "bold !important",
              },
            }}
          />
          {!openBrand ? (
            <AiOutlineRight
              id="basic-brand-button"
              aria-controls={openColor ? "basic-brand-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openBrand ? "true" : undefined}
              onClick={handleClickBrand}
            />
          ) : (
            <AiOutlineDown />
          )}
          <BrandPopup
            dummy={dummy}
            anchorEl={anchorElBrand}
            open={openBrand}
            productDataList={productDataList}
            setSendBrandandSuppliers={setSendBrandandSuppliers}
            setSendBrandName={setSendBrandName}
            handleClose={handleCloseBrand}
            setFetchTranslationList={setFetchTranslationList}
            FetchTranslationList={FetchTranslationList}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          enuItem
          sx={{
            display: "flex !important",
            justifyContent: "space-between !important",
            paddingRight: "0",
            "&:hover": { background: "transparent", cursor: "default" },
            marginBottom: "7px",
          }}
        >
          <FormControlLabel
            // value="Categories"
            value={t("Categories")}
            control={
              <Radio
                icon={<MdOutlineLens fontSize="2rem" />}
                checkedIcon={<MdLens color="#00246a" fontSize="2rem" />}
                checked={isCatChecked}
                onClick={() => {
                  setIsCatChecked(!isCatChecked);
                  // setFilterItem("Categories");
                  setIsPartsChecked(false);
                  setIsServiceChecked(false);
                  setIsProductChecked(false);
                  setIsBrandChecked(false);
                  setIsCatChecked(true);
                  setIsColorChecked(false);
                  setAnchorElCat(true);

                  setSelectedFilteredItem("Categories");
                }}
              />
            }
            // label="Categories"
            label={t("Categories")}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px !important",
                color: `${isCatChecked} ? #00246A : #333333`,
                fontWeight: isCatChecked ? "800 !important" : "bold !important",
              },
            }}
          />
          {!openCat ? (
            <AiOutlineRight
              id="basic-cat-button"
              aria-controls={openCat ? "basic-cat-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openCat ? "true" : undefined}
              onClick={handleClickCat}
            />
          ) : (
            <AiOutlineDown />
          )}
          <CatPopup
            dummy={dummy}
            anchorEl={anchorElCat}
            open={openCat}
            productDataList={productDataList}
            setSendCategories={setSendCategories}
            handleClose={handleCloseCat}
          />
        </MenuItem>

        <MenuItem
          onClick={() => {
            setFilterItem("");
            setIsPartsChecked(false);
            setIsServiceChecked(false);
            setIsProductChecked(false);
            setIsBrandChecked(false);
            setIsCatChecked(false);
            setIsColorChecked(false);
            setSendClearFilter(true);
            handleClose();

            setSelectedFilteredItem("");
          }}
          disableRipple
          enuItem
          sx={{ "&:hover": { background: "transparent", cursor: "default" } }}
        >
          <div className="filter-popup-clear-btn-con">
            <div className="pro-part-add-itm-btn filter-popup-clear-btn d-flex">
              <div className="pro-part-add-itm-btn-text">
                {/* Clear */}
                {t("Clear")}
              </div>
            </div>
          </div>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

function ProFilter({
  setFilterItem,
  filterItem,
  productDataList,
  setSendColor,
  setSendBrandandSuppliers,
  setSendBrandName,
  setSendCategories,
  setSendClearFilter,
}) {
  console.log("asc45", productDataList);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedFilteredItem, setSelectedFilteredItem] = React.useState("");

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Products And Services").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <div className="pro-part-filter-con">
      <div className="pro-part-filter-label-con">
        <div>
          {/* Filters */}
          {t("Filters")}
        </div>
        <Image
          // height={16}
          // width={19}
          src={actfilter}
          className="pro-part-add-itm-btn-icn"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        />
        <FilterPopup
          anchorEl={anchorEl}
          open={open}
          setFilterItem={setFilterItem}
          productDataList={productDataList}
          setSendColor={setSendColor}
          setSendBrandandSuppliers={setSendBrandandSuppliers}
          setSendBrandName={setSendBrandName}
          setSendCategories={setSendCategories}
          setSendClearFilter={setSendClearFilter}
          handleClose={handleClose}
          setSelectedFilteredItem={setSelectedFilteredItem}
          setFetchTranslationList={setFetchTranslationList}
          FetchTranslationList={FetchTranslationList}
        />

        <div className="filterdItem">
          <div className="borderRight">
            <h6>{selectedFilteredItem ? selectedFilteredItem : "All"}</h6>
          </div>
          <img
            className="crossIcon"
            src={crossIcon}
            alt=""
            onClick={() => {
              setFilterItem("");
              // setIsPartsChecked(false);
              // setIsProductChecked(false);
              // setIsBrandChecked(false);
              // setIsCatChecked(false);
              // setIsColorChecked(false);
              setSendClearFilter(true);
              handleClose();

              setSelectedFilteredItem("");
            }}
          />
        </div>
      </div>

      {filterItem && (
        <div>
          <SelectedFilter
            filterItem={filterItem}
            setFilterItem={setFilterItem}
          />
        </div>
      )}
    </div>
  );
}

export default ProFilter;
